// import React from 'react';
// import { 
//   Building2, Scale, ShieldAlert, Key, 
//   CheckCircle, ChevronLeft, Landmark, Layers, 
//   HelpCircle, BarChart3 
// } from 'lucide-react'; // run: npm i lucide-react
// import { ServicePageHeader } from '../ServicePageHeader';

// export default function JudicialCustodyServices() {
  
//   // Scope of custody and estate administration modules
//   const estateServices = [
//     {
//       title: "إدارة الحراسة القضائية",
//       desc: "تولي الإدارة القانونية والمالية للأموال والشركات المتنازع عليها بأمر قضائي، وضمان استمرار تشغيلها وحمايتها من التبديد أو الاستغلال.",
//       icon: <Key className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "حصر وجرد التركات المعقدة",
//       desc: "تتبع وحصر كافة أصول التركة (عقارات، أسهم، نقدية، شركات داخل وخارج المملكة) وإعداد كشوفات الجرد الرسمية والمالية بدقة.",
//       icon: <Layers className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "تقييم الأصول وتصفية الديون",
//       desc: "التنسيق مع المقيمين المعتمدين (تقييم) لمعرفة القيمة السوقية العادلة للتركة، وسداد الديون والالتزامات الشرعية والنظامية المترتبة عليها.",
//       icon: <BarChart3 className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "القسمة الرضائية والقضائية",
//       desc: "إعداد محاضر القسمة الرضائية وتوثيقها، أو صياغة خطط الإفراز والتوزيع القضائي ومتابعة إفراغ الصكوك ونقل الملكيات للورثة.",
//       icon: <Scale className="w-6 h-6 text-amber-600" />
//     }
//   ];

//   return (
//     <div className="bg-slate-50 text-right font-sans" dir="rtl">
//       <ServicePageHeader 
//         title="خدمات الحراسة القضائية وتصفية التركات"
//         description="نقدم حلولاً قانونية وميدانية متكاملة لإدارة التركات المتنازع عليها وحمايتها، وتولي مهام الحراسة والتصفية بكفاءة تضمن استقرار الكيانات التجارية وتوزيع الحقوق وفق الشريعة والنظام."
//       />
//       {/* Hero Header Section */}
//       <section className="relative bg-slate-900 text-white py-24 px-4 overflow-hidden">
//         <div className="absolute inset-0 opacity-15 bg-[url('https://images.unsplash.com/photo-1582407947304-fd86f028f716?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
//         <div className="max-w-6xl mx-auto relative z-10 text-center">
//           <span className="text-amber-500 font-semibold text-sm md:text-base tracking-wide block mb-3">حفظ الحقوق وإدارة الأصول بنزاهة واحترافية</span>
//           <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">خدمات الحراسة القضائية وتصفية التركات</h1>
//           <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
//             نقدم حلولاً قانونية وميدانية متكاملة لإدارة التركات المتنازع عليها وحمايتها، وتولي مهام الحراسة والتصفية بكفاءة تضمن استقرار الكيانات التجارية وتوزيع الحقوق وفق الشريعة والنظام.
//           </p>
//         </div>
//       </section>

//       {/* Strategic and Structural Importance */}
//       <section className="max-w-6xl mx-auto py-20 px-4">
//         <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100 flex flex-col lg:flex-row gap-12 items-center">
//           <div className="flex-1">
//             <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-6 leading-tight">
//               حماية التركات من التجميد والانهيار الاقتصادي
//             </h2>
//             <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-4">
//               غالباً ما تؤدي الخلافات بين الورثة أو الشركاء إلى شلل تام في إدارة الأصول العقارية أو الشركات القائمة، مما يعرضها لخسائر فادحة وتراجع في قيمتها السوقية نتيجة غياب صاحب القرار الموحد.
//             </p>
//             <p className="text-gray-600 text-base md:text-lg leading-relaxed">
//               بصفتنا مكتباً مؤهلاً لتولي مهام الحراسة القضائية والتصفية، نعمل كجهة محايدة وموثوقة تحت إشراف القضاء أو باتفاق الأطراف. نقوم بمسؤولية الإشراف الكامل على النفقات والإيرادات، وإعداد التقارير المالية الدورية، والوصول بالملف إلى التصفية النهائية والتوزيع العادل الذي يحمي الروابط العائلية والاستثمارية.
//             </p>
//           </div>
          
//           {/* Quick Core Objectives Checklist */}
//           <div className="w-full lg:w-80 bg-slate-900 text-white p-6 rounded-xl border border-slate-800 space-y-4 shadow-lg">
//             <h3 className="font-bold text-amber-500 text-base flex items-center gap-2">
//               <Landmark className="w-5 h-5" /> أهداف الحراسة والتصفية:
//             </h3>
//             <ul className="space-y-3 text-xs text-slate-300">
//               <li className="flex items-center gap-2">
//                 <CheckCircle className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>منع انفراد بعض الأطراف بالتصرف في أموال التركة.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <CheckCircle className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>استمرارية تشغيل الشركات والمصانع وتدفق رواتب موظفيها.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <CheckCircle className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>تحصيل حقوق الموروث لدى الغير وسداد ديونه النظامية.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <CheckCircle className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>تسريع إجراءات القسمة والفرز وتجنب طول أمد التقاضي.</span>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </section>

//       {/* Grid: Scope of Work */}
//       <section className="max-w-6xl mx-auto py-12 px-4">
//         <div className="text-center mb-16">
//           <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-3">خدماتنا في إدارة التركات والنزاعات الماليّة</h2>
//           <p className="text-gray-500">منظومة إجرائية متكاملة تبدأ من وضع اليد وحتى تسليم الصكوك والمستندات المفرزة</p>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//           {estateServices.map((service, index) => (
//             <div key={index} className="bg-white p-8 rounded-xl border border-gray-100 hover:border-amber-500 hover:shadow-md transition-all duration-300">
//               <div className="p-3 bg-slate-50 rounded-lg w-fit text-slate-700 mb-4">
//                 {service.icon}
//               </div>
//               <h3 className="text-xl font-bold text-slate-800 mb-2">{service.title}</h3>
//               <p className="text-gray-500 text-sm leading-relaxed">{service.desc}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Regulatory/Procedural Alert */}
//       <section className="max-w-4xl mx-auto py-16 px-4">
//         <div className="bg-amber-50 rounded-xl border border-amber-200 p-6 flex gap-4 items-start">
//           <ShieldAlert className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" />
//           <div>
//             <h4 className="font-bold text-slate-800 mb-1">تنبيه قانوني بشأن الشركات العائلية:</h4>
//             <p className="text-amber-950 text-sm leading-relaxed">
//               وفقاً لنظام الشركات الجديد، فإن وفاة أحد الشركاء في الشركات ذات المسؤولية المحدودة أو المساهمة المغلقة لا يؤدي إلى انقضاء الشركة، بل تنتقل الحصص إلى الورثة. لتفادي تجميد حسابات الشركة، يُنصح الورثة بتعيين ممثل قانوني واحد أو طلب الحراسة القضائية الاتفاقية فوراً لتسيير أعمال الشركة وحماية حصتها السوقية.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Action Banner for Conversion */}
//       <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
//         <div className="inline-flex p-3 bg-slate-100 rounded-full text-slate-800 mb-4">
//           <Building2 className="w-6 h-6" />
//         </div>
//         <h3 className="text-xl font-bold text-slate-800 mb-2">هل تواجه تحديات في إدارة أو تقسيم تركة مشتركة؟</h3>
//         <p className="text-gray-500 text-sm max-w-xl mx-auto mb-6">
//           يتولى فريقنا المتخصص دراسة وضع التركة والأصول، وتقديم الاستشارة الأنسب لك سواء عبر مسار التصفية الودية أو إقامة دعوى الحراسة القضائية أمام المحكمة المختصة.
//         </p>
//         <button className="bg-amber-600 text-white font-medium text-sm px-6 py-3 rounded-lg hover:bg-amber-700 transition-colors shadow-md inline-flex items-center gap-2">
//           طلب استشارة متخصصة في التركات والحراسة
//           <ChevronLeft className="w-4 h-4" />
//         </button>
//       </section>

//     </div>
//   );
// }


import React from 'react';
import { 
  Building2, Scale, ShieldAlert, Key, 
  CheckCircle, ChevronLeft, Landmark, Layers, 
  HelpCircle, BarChart3 
} from 'lucide-react';
import { ServicePageHeader } from '../ServicePageHeader';
import { openWhatsApp } from '../utils';

export default function JudicialCustodyServices() {
  
  // Scope of custody and estate administration modules - Refactored to Navy Light
  const estateServices = [
    {
      title: "إدارة الحراسة القضائية",
      desc: "تولي الإدارة القانونية والمالية للأموال والشركات المتنازع عليها بأمر قضائي، وضمان استمرار تشغيلها وحمايتها من التبديد أو الاستغلال.",
      icon: <Key className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "حصر وجرد التركات المعقدة",
      desc: "تتبع وحصر كافة أصول التركة (عقارات، أسهم، نقدية، شركات داخل وخارج المملكة) وإعداد كشوفات الجرد الرسمية والمالية بدقة.",
      icon: <Layers className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "تقييم الأصول وتصفية الديون",
      desc: "التنسيق مع المقيمين المعتمدين (تقييم) لمعرفة القيمة السوقية العادلة للتركة، وسداد الديون والالتزامات الشرعية والنظامية المترتبة عليها.",
      icon: <BarChart3 className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "القسمة الرضائية والقضائية",
      desc: "إعداد محاضر القسمة الرضائية وتوثيقها، أو صياغة خطط الإفراز والتوزيع القضائي ومتابعة إفراغ الصكوك ونقل الملكيات للورثة.",
      icon: <Scale className="w-6 h-6 text-indigo-950" />
    }
  ];

  return (
    <div className="bg-white text-right font-sans min-h-screen" dir="rtl">
      <ServicePageHeader 
        title="خدمات الحراسة القضائية وتصفية التركات"
        description="نقدم حلولاً قانونية وميدانية متكاملة لإدارة التركات المتنازع عليها وحمايتها، وتولي مهام الحراسة والتصفية بكفاءة تضمن استقرار الكيانات التجارية وتوزيع الحقوق وفق الشريعة والنظام."
      />
      
      {/* Hero Header Section - Converted to Premium Light Mode */}
      <section className="relative bg-slate-50 border-b border-slate-100 py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1582407947304-fd86f028f716?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
        {/* White/Slate overlay for premium executive appearance */}
        <div className="absolute inset-0 bg-white/90 backdrop-blur-[1px]"></div>
        
        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="text-blue-700 font-bold text-xs md:text-sm tracking-wide block mb-3 uppercase">حفظ الحقوق وإدارة الأصول بنزاهة واحترافية</span>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-6 text-indigo-950 leading-tight">خدمات الحراسة القضائية وتصفية التركات</h1>
          <p className="text-slate-600 max-w-3xl mx-auto text-base md:text-lg leading-relaxed font-light">
            نقدم حلولاً قانونية وميدانية متكاملة لإدارة التركات المتنازع عليها وحمايتها، وتولي مهام الحراسة والتصفية بكفاءة تضمن استقرار الكيانات التجارية وتوزيع الحقوق وفق الشريعة والنظام.
          </p>
        </div>
      </section>

      {/* Strategic and Structural Importance */}
   {/* Asset Protection & Liquidation - Optimized Responsive Desktop Layout */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-slate-200/60 flex flex-col lg:flex-row gap-8 lg:gap-12 items-center lg:items-stretch">
          
          {/* Main Text Content */}
          <div className="flex-1">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-6 leading-tight">
              حماية التركات من التجميد والانهيار الاقتصادي
            </h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-4 font-light">
              غالباً ما تؤدي الخلافات بين الورثة أو الشركاء إلى شلل تام في إدارة الأصول العقارية أو الشركات القائمة، مما يعرضها لخسائر فادحة وتراجع في قيمتها السوقية نتيجة غياب صاحب القرار الموحد.
            </p>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed font-light">
              بصفتنا مكتباً مؤهلاً لتولي مهام الحراسة القضائية والتصفية، نعمل كجهة محايدة وموثوقة تحت إشراف القضاء أو باتفاق الأطراف. نقوم بمسؤولية الإشراف الكامل على النفقات والإيرادات، وإعداد التقارير المالية الدورية، والوصول بالملف إلى التصفية النهائية والتوزيع العادل الذي يحمي الروابط العائلية والاستثمارية.
            </p>
          </div>
          
          {/* Quick Core Objectives Checklist - Fixed Desktop Responsiveness */}
          <div className="w-full lg:w-96 lg:max-w-md shrink-0 bg-indigo-950 text-white p-8 rounded-xl border border-indigo-900/50 space-y-5 shadow-md flex flex-col justify-center">
            <h3 className="font-bold text-white text-base flex items-center gap-2 border-b border-white/10 pb-3">
              <Landmark className="w-5 h-5 text-blue-400" /> أهداف الحراسة والتصفية:
            </h3>
            <ul className="space-y-4 text-xs md:text-sm text-slate-200 font-light">
              <li className="flex items-start gap-2.5">
                <CheckCircle className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
                <span>منع انفراد بعض الأطراف بالتصرف في أموال التركة.</span>
              </li>
              <li className="flex items-start gap-2.5">
                <CheckCircle className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
                <span>استمرارية تشغيل الشركات والمصانع وتدفق رواتب موظفيها.</span>
              </li>
              <li className="flex items-start gap-2.5">
                <CheckCircle className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
                <span>تحصيل حقوق الموروث لدى الغير وسداد ديونه النظامية.</span>
              </li>
              <li className="flex items-start gap-2.5">
                <CheckCircle className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
                <span>تسريع إجراءات القسمة والفرز وتجنب طول أمد التقاضي.</span>
              </li>
            </ul>
          </div>

        </div>
      </section>
      {/* Grid: Scope of Work - Converted to Premium Light Grid */}
      <section className="bg-slate-50/50 border-y border-slate-100 py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">خدماتنا في إدارة التركات والنزاعات الماليّة</h2>
            <p className="text-slate-500 text-sm md:text-base font-light">منظومة إجرائية متكاملة تبدأ من وضع اليد وحتى تسليم الصكوك والمستندات المفرزة</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {estateServices.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border-t-4 border-t-indigo-950 border-x border-b border-slate-100 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="bg-slate-50 p-3 rounded-lg w-fit mb-5">
                  {service.icon}
                </div>
                <h3 className="text-xl font-bold text-indigo-950 mb-2">{service.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed font-light">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Regulatory/Procedural Alert - Adjusted to Slate Balance Tone */}
      <section className="max-w-4xl mx-auto py-20 px-4">
        <div className="bg-slate-50 rounded-xl border border-slate-200/60 p-6 flex gap-4 items-start shadow-sm">
          <ShieldAlert className="w-6 h-6 text-indigo-950 shrink-0 mt-0.5" />
          <div>
            <h4 className="font-bold text-indigo-950 mb-1">تنبيه قانوني بشأن الشركات العائلية:</h4>
            <p className="text-slate-600 text-sm leading-relaxed font-light">
              وفقاً لنظام الشركات الجديد، فإن وفاة أحد الشركاء في الشركات ذات المسؤولية المحدودة أو المساهمة المغلقة لا يؤدي إلى انقضاء الشركة، بل تنتقل الحصص إلى الورثة. لتفادي تجميد حسابات الشركة، يُنصح الورثة بتعيين ممثل قانوني واحد أو طلب الحراسة القضائية الاتفاقية فوراً لتسيير أعمال الشركة وحماية حصتها السوقية.
            </p>
          </div>
        </div>
      </section>

      {/* Action Banner for Conversion - Refactored Styles */}
      <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
        <div className="inline-flex p-3 bg-slate-50 rounded-full text-indigo-950 border border-slate-100 shadow-sm mb-4">
          <Building2 className="w-6 h-6 text-blue-700" />
        </div>
        <h3 className="text-xl font-bold text-indigo-950 mb-2">هل تواجه تحديات في إدارة أو تقسيم تركة مشتركة؟</h3>
        <p className="text-slate-500 text-sm max-w-xl mx-auto mb-6 font-light">
          يتولى فريقنا المتخصص دراسة وضع التركة والأصول، وتقديم الاستشارة الأنسب لك سواء عبر مسار التصفية الودية أو إقامة دعوى الحراسة القضائية أمام المحكمة المختصة.
        </p>
        <button
          onClick={() => openWhatsApp( "   طلب استشارة متخصصة في التركات والحراسة  ")} 
        
        className="bg-indigo-950 text-white font-bold text-sm px-6 py-3 rounded-lg hover:bg-slate-900 transition-all duration-200 shadow-sm inline-flex items-center gap-2">
          طلب استشارة متخصصة في التركات والحراسة
          <ChevronLeft className="w-4 h-4" />
        </button>
      </section>

    </div>
  );
}